import { type Route } from "../core";
import { type OfferPage } from "./Offer";

/**
 * Public offer route.
 */
export default {
  path: "/oferta",
  component: () => import(/* webpackChunkName: "secondary" */ "./Offer"),
  response: () => ({
    title:
      "Договор (публичная оферта) купли-продажи товаров и купонов на скидку",
    description:
      "Публичная оферта интернет-магазина MadNuts.ru на продажу товаров и купонов на скидку дистанционным способом",
    keywords:
      "оферта, договор, купоны, юридическая информация, орехи, сухофрукты, MadNuts.ru",
    ogDescription:
      "Публичная оферта интернет-магазина MadNuts.ru на продажу товаров и купонов на скидку дистанционным способом",
  }),
} as Route<OfferPage>;
